module.exports = __webpack_public_path__ + "media/images/icons/close-red-cdb5ad5bd0ffb4fdf2da135d8ec5c336.svg";